import { Box, BoxProps, ColorOptions, ModBox } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import React, { useCallback, useEffect, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../../components/Container'
import { NewVerticalStepIndicator } from '../../../components/NewVerticalStepIndicator'
import { useLazyApiData, useStores } from '../../../data/store'
import { compareArray, getValueFromLOVDescription, LOV_CODES, MessageTypes, zoomOutIfRequire } from '../../../utils'
import { STORE_MERCHANT } from '../../../utils/constants'

import { NewTable } from '../../../components/NewTable'
import { getFormattedDate } from '../../../network/eosCreateWorkItem'
import { CheckerDetailsFooter } from '../CheckerDetails/CheckerDetailsFooter'
import { SCREEN_MAAPPER_CHECKER_MY_TASK } from '../MyOnboardedEntityQueue'
import { EntityOnboardingForm } from '../OnboardEntity/EntityOnboardingForm'
import { EntityOnboardingHeader } from '../OnboardEntity/EntityOnboardingHeader'
import { FullScreenLoader } from '../OnboardEntity/comps/FullScreenLoader'

const modifiedMapperMetadata = (initialValue, usertype, dropDownData) => {
  switch (usertype) {
    case 'checker2MyQueue':
      if (
        getValueFromLOVDescription(dropDownData?.lovData, initialValue?.businessChannel, 'BusinessChannel') !==
          LOV_CODES.ONLINE &&
        initialValue.requestType === 'NEW_PROFILE'
      ) {
        return {
          ...SCREEN_MAAPPER_CHECKER_MY_TASK[usertype],
          totalFilledStep: 9,
          onBoardingSteps: SCREEN_MAAPPER_CHECKER_MY_TASK[usertype].onBoardingSteps.slice(0, -1),
        }
      }
      break
    case 'riskMakerMyQueue':
    case 'riskCheckerMyQueue':
      if (!['UPDATE_PROFILE', 'RISK_UPDATE_PROFILE'].includes(initialValue.requestType)) {
        return {
          ...SCREEN_MAAPPER_CHECKER_MY_TASK[usertype],
          totalFilledStep: 10,
          onBoardingSteps: SCREEN_MAAPPER_CHECKER_MY_TASK[usertype].onBoardingSteps.slice(0, -1),
        }
      }
      break
  }
  return SCREEN_MAAPPER_CHECKER_MY_TASK[usertype]
}

const MyOnboardedEntityDetails = () => {
  const {
    fetchGroupData,
    updateEntityStatusAsync,
    setMessage,
    updateTerminalsState,
    fetchMccProgramDetails,
    loadInitials,
  } = useStores((store) => ({
    fetchGroupData: store.entityOnboarding.getGroupData,
    updateEntityStatusAsync: store.entityOnboarding.updateEntityStatusAsync,
    setMessage: store.message.setMessage,
    updateTerminalsState: store.entityOnboarding.updateTerminalsState,
    fetchMccProgramDetails: store.fetchMccProgramDetails,
    loadInitials: store.entityOnboarding.loadInitials,
  }))
  const route: any = useRoute()
  const navigation: any = useNavigation()
  const savedData = JSON.parse(localStorage.getItem('queryParams'))
  const [entityDetails, setEntityDetails] = useState(JSON.parse(JSON.stringify(route?.params?.item ?? savedData?.item)))
  const [lazyFetchMccDetails, fetchMccProgramDetailsHandler] = useLazyApiData(fetchMccProgramDetails)

  const USER_TYPE = route?.params?.name ?? savedData?.name
  const [fetchGroupDataApi, fetchGroupDataHandler] = useLazyApiData(fetchGroupData)
  const [isGroupDataLoading, setGroupDataLoading] = useState(
    !entityDetails.parentEntityId && !!entityDetails.parentGroupId && !!entityDetails.parentSubGroupId,
  )
  const [requestId, setRequestId] = useState(`UPDATE-${getFormattedDate()}`)

  const [lazyLoadInitials, loadInitialHandler] = useLazyApiData(loadInitials)
  const nativeID = `myDetails_${USER_TYPE}`
  useEffect(() => {
    zoomOutIfRequire(nativeID)
  }, [])

  const [terminals, setTerminals] = useState(
    entityDetails?.terminals?.map((item) => ({
      ...item,
      isSelected: item?.action === 'CREATE' && ['checker2MyQueue'].includes(USER_TYPE) ? true : false,
    })),
  )

  const [currentStep, setCurrentStep] = useState(
    ['riskCheckerMyQueue', 'riskMakerMyQueue'].includes(USER_TYPE) ? 10 : 1,
  )
  useEffect(() => {
    if (!entityDetails.parentEntityId && entityDetails.parentGroupId && entityDetails.parentSubGroupId) {
      fetchGroupDataApi(entityDetails.parentGroupId, entityDetails.parentSubGroupId)
    }
    if (entityDetails?.mccCodeComponent?.mccCode?.length > 0) {
      lazyFetchMccDetails(entityDetails?.mccCodeComponent?.mccCode, '')
    }
    entityDetails?.requestType !== 'BULK_TERMINAL_ADD' && lazyLoadInitials()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (fetchMccProgramDetailsHandler?.state === 'fulfilled') {
      setEntityDetails({
        ...entityDetails,
        mccCodeComponent: {
          businessLine: {
            key: fetchMccProgramDetailsHandler?.data?.businessLine,
            value: fetchMccProgramDetailsHandler?.data?.businessLine,
          },
          businessCategory: fetchMccProgramDetailsHandler?.data?.businessDetails?.[0]?.businessCategory,
          mccCode: fetchMccProgramDetailsHandler?.data?.businessDetails?.[0]?.mccCode,
        },
      })
    }
  }, [fetchMccProgramDetailsHandler?.state])
  console.log('htag fetchMccProgramDetailsHandler', fetchMccProgramDetailsHandler)
  useEffect(() => {
    if (fetchGroupDataHandler.state === 'fulfilled') {
      const { groupName, subGroupName } = fetchGroupDataHandler.data
      setEntityDetails({ ...entityDetails, parentGroupName: groupName, parentSubGroupName: subGroupName })
      setGroupDataLoading(false)
    } else if (fetchGroupDataHandler.state === 'rejected') {
      setGroupDataLoading(false)
    }
  }, [fetchGroupDataHandler.state])
  const isItemEditable =
    SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.validStatesForAction?.includes(entityDetails?.applicationStatus) &&
    !['riskCheckerMyQueue', 'checker2MyQueue'].includes(USER_TYPE)
  const [editable, setEditable] = useState(false)
  const [formValidationStatus, setFormValidationStatus] = useState(
    modifiedMapperMetadata(entityDetails, USER_TYPE, loadInitialHandler?.data)?.onBoardingSteps?.map(
      (_, index) => index !== 0,
    ),
  )

  console.log('hatbddentityDetails=', entityDetails)
  const isFormValid = useCallback(
    (values, step) => {
      if (step === 3) {
        if (values.merchantType === STORE_MERCHANT) {
          return true
        }
        if (
          (!values?.authSignatoryPoA_docs_data || values?.authSignatoryPoA_docs_data?.length === 0) &&
          (!values?.authSignatoryPoA_docs_data_jdms || values?.authSignatoryPoA_docs_data_jdms?.length === 0)
        ) {
          return false
        } else if (
          (!values?.authSignatoryPoi_docs_data || values?.authSignatoryPoi_docs_data?.length === 0) &&
          (!values?.authSignatoryPoi_docs_data_jdms || values?.authSignatoryPoi_docs_data_jdms?.length === 0)
        ) {
          return false
        } else if (!values.authSignatoryCity || !values.authSignatoryState) {
          return false
        }
      } else if (step === 4) {
        if (
          (!values?.businessDetailsPob_docs_data || values?.businessDetailsPob_docs_data?.length === 0) &&
          (!values?.businessDetailsPob_docs_data_jdms || values?.businessDetailsPob_docs_data_jdms?.length === 0) &&
          values.merchantType !== STORE_MERCHANT
        ) {
          return false
        } else if (!values.city || !values.state) {
          return false
        }
      } else if (step === 6) {
        if (
          (!values?.canceled_check_docs_data || values?.canceled_check_docs_data?.length === 0) &&
          (!values?.canceled_check_docs_data_jdms || values?.canceled_check_docs_data_jdms?.length === 0) &&
          values.merchantType !== STORE_MERCHANT
        ) {
          return false
        }
      }
      return true
    },
    [formValidationStatus],
  )

  useEffect(() => {
    route?.params && localStorage.setItem('queryParams', JSON.stringify(route?.params))
  }, [route?.params])

  const [lazyUpdateEntityStatus, uploadEntityStatusHandler] = useLazyApiData(updateEntityStatusAsync)
  const [lazyUpdateTerminalsState, updateTerminalsStateHandler] = useLazyApiData(updateTerminalsState)
  const [lastRequest, setLastRequest] = useState({})
  const [lastDedupeData, setLastDedupeData] = useState({})

  const formRef = React.useRef(null)
  const { width } = useWindowDimensions()

  const onStepPressed = useCallback((pressedStep: any) => {
    setCurrentStep(pressedStep)
  }, [])

  const onSubmit = useCallback(
    (action, comment, internalComment) => {
      console.log('action=', action)
      console.log('comments=', comment)
      lazyUpdateEntityStatus(
        {
          editedValues: formRef?.current?.getValues(),
          action,
          comment,
          internalComment,
          applicationId: requestId,
        },
        lastRequest,
        lastDedupeData,
        USER_TYPE === 'checker1MyQueue' &&
          (action === 'APPROVE' || action === 'RISK_REFER') &&
          !entityDetails?.skipDedupe,
      )
    },
    [lazyUpdateEntityStatus, lastRequest, lastDedupeData, USER_TYPE, entityDetails],
  )
  useEffect(() => {
    if (uploadEntityStatusHandler.state === 'rejected') {
      if (uploadEntityStatusHandler.data?.dedupeFound) {
        setLastRequest(uploadEntityStatusHandler.data.lastRequest)
        setLastDedupeData(uploadEntityStatusHandler.data.dedupeResponse)
      }
    } else if (uploadEntityStatusHandler.state === 'fulfilled' || updateTerminalsStateHandler?.state === 'fulfilled') {
      setMessage('Action updated sucessfully.', MessageTypes.SUCCESS)
      setLastRequest({})
      setLastDedupeData({})
      navigation.reset({
        index: 0,
        routes: [{ name: USER_TYPE }],
      })
    }
  }, [uploadEntityStatusHandler.state, updateTerminalsStateHandler?.state])

  const getSubmitActions = useCallback(
    ({ businessChannel, requestType }, dropDownData) => {
      if (USER_TYPE === 'checker1MyQueue') {
        return SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.submitActions?.filter((item) => {
          if (entityDetails?.applicationStatus === 'OPS_HOLD' && item.key !== 'RELEASE_HOLD') {
            return false
          }
          if (entityDetails?.applicationStatus !== 'OPS_HOLD' && item.key === 'RELEASE_HOLD') {
            return false
          }
          if (
            getValueFromLOVDescription(dropDownData?.lovData, businessChannel, 'BusinessChannel') ===
              LOV_CODES.ONLINE &&
            requestType !== 'UPDATE_PROFILE' &&
            item.key === 'APPROVE'
          ) {
            return false
          }
          if (
            (getValueFromLOVDescription(dropDownData?.lovData, businessChannel, 'BusinessChannel') ===
              LOV_CODES.PHYSICAL ||
              requestType === 'UPDATE_PROFILE') &&
            item.key === 'RISK_REFER'
          ) {
            return false
          }
          if (requestType === 'NEW_PROFILE' && item.key === 'REWORK') {
            return false
          }
          return true
        })
      } else if (USER_TYPE === 'riskMakerMyQueue') {
        return SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.submitActions?.filter((item) => {
          if (entityDetails?.applicationStatus === 'RISK_HOLD' && item.key !== 'RELEASE_HOLD') {
            return false
          }
          if (entityDetails?.applicationStatus !== 'RISK_HOLD' && item.key === 'RELEASE_HOLD') {
            return false
          }
          return true
        })
      }
      return SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.submitActions
    },
    [USER_TYPE, entityDetails?.businessChannel],
  )
  const renderActionButton = useCallback(
    (props: any) => {
      console.log('props=', props)
      const allStepValidationStatus = props.allStepValidationStatus?.map((item, index) => {
        return item && isFormValid(props?.values, index + 1)
      })
      if (['checker2MyQueue', 'riskCheckerMyQueue'].includes(USER_TYPE)) {
        //allStepValidationStatus[0] = true
        //allStepValidationStatus[allStepValidationStatus.length - 1] = true
        allStepValidationStatus.fill(true, 0, allStepValidationStatus.length)
      } else if (['riskMakerMyQueue'].includes(USER_TYPE)) {
        allStepValidationStatus.fill(true, 0, allStepValidationStatus.length - 2)
      }
      const isChanged = !compareArray(allStepValidationStatus, formValidationStatus)
      if (isChanged) {
        setFormValidationStatus([...allStepValidationStatus])
      }
      const totalSteps = modifiedMapperMetadata(entityDetails, USER_TYPE, loadInitialHandler?.data)?.totalFilledStep
      const shouldShowFooter =
        SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.validStatesForAction?.includes(entityDetails?.applicationStatus) &&
        currentStep === totalSteps
      return (
        <CheckerDetailsFooter
          show={shouldShowFooter}
          isCurrentFormValid={
            !['riskMakerMyQueue', 'checker1MyQueue'].includes(USER_TYPE) ||
            allStepValidationStatus.every((item) => item)
          }
          commentTitle={SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.commentTitle}
          internalCommentTitle={SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.internalCommentTitle}
          editable={editable || ['riskCheckerMyQueue', 'checker2MyQueue'].includes(USER_TYPE)}
          onSubmit={onSubmit}
          showInternalCommentsField={['riskCheckerMyQueue', 'riskMakerMyQueue'].includes(USER_TYPE)}
          submitActions={getSubmitActions(props?.values, loadInitialHandler?.data)}
          showUploadFileComp={
            ['riskCheckerMyQueue', 'riskMakerMyQueue'].includes(USER_TYPE) &&
            ['UPDATE_PROFILE', 'RISK_UPDATE_PROFILE'].includes(entityDetails.requestType)
          }
          merchantId={entityDetails.entityId}
          requestId={requestId}
        />
      )
    },
    [
      formValidationStatus,
      currentStep,
      USER_TYPE,
      entityDetails?.applicationStatus,
      editable,
      onSubmit,
      getSubmitActions,
      isFormValid,
    ],
  )

  const toggleEdit = useCallback(() => setEditable(!editable), [editable])

  const onBackPress = useCallback(() => {
    navigation.reset({
      index: 0,
      routes: [{ name: USER_TYPE }],
    })
  }, [USER_TYPE, navigation])

  const onTerminalListSubmit = useCallback(
    (action) => {
      console.log('htag entityDetails=', entityDetails)
      const atleastOneSelected = terminals?.find((terminal) => terminal?.isSelected)
      if (action === 'APPROVE' && !atleastOneSelected && !['checker2MyQueue'].includes(USER_TYPE)) {
        setMessage('Please select atleast 1 terminal to approve', MessageTypes.ERROR)
      } else {
        lazyUpdateTerminalsState(
          {
            action,
            ...(action === 'APPROVE' &&
              !['checker2MyQueue'].includes(USER_TYPE) && {
                merchant: {
                  entityIdentificationNumber: entityDetails?.entityIdentificationNumber,
                  terminals: terminals?.map((terminal) => ({
                    ...terminal,
                    ...((terminal?.action !== 'UPDATE' || !terminal?.isSelected) && {
                      action: terminal?.isSelected ? 'CREATE' : 'DISCARD',
                    }),
                    isSelected: undefined,
                  })),
                },
              }),
          },
          entityDetails?.taskInstanceId,
        )
      }
    },
    [USER_TYPE, entityDetails, lazyUpdateTerminalsState, setMessage, terminals],
  )

  const getIsAllSelected = useCallback(
    (isAllSelected) => setTerminals(terminals.map((terminal) => ({ ...terminal, isSelected: isAllSelected }))),
    [],
  )
  const onCheckChange = useCallback((isChecked, index) => {
    terminals[index].isSelected = isChecked
    setTerminals([...terminals])
  }, [])

  return (
    <Box h="100%" w="100%" overflow={'hidden'} padding={5}>
      <Container
        {...styles.container}
        isLoading={
          entityDetails?.requestType !== 'BULK_TERMINAL_ADD' &&
          (loadInitialHandler?.state === 'pending' || !loadInitialHandler?.state || !loadInitialHandler.data)
        }
        nativeID={nativeID}
        onRetry={lazyLoadInitials}
        errorMessage={loadInitialHandler?.data?.message}>
        <EntityOnboardingHeader
          title={entityDetails?.businessDisplayName}
          applicationId={entityDetails?.applicationId}
          applicationStatus={entityDetails?.applicationStatus}
          businessChannel={entityDetails?.businessChannel}
          entityId={entityDetails?.entityIdentificationNumber}
          requestType={entityDetails?.requestType}
          onboardingChannel={entityDetails?.onboardingChannel}
          showBackButton={true}
          toggleEdit={toggleEdit}
          editable={editable}
          showEditButton={isItemEditable}
          onBackPress={onBackPress}
        />
        <Container
          isLoading={isGroupDataLoading || fetchMccProgramDetailsHandler?.state === 'pending'}
          show={entityDetails?.requestType !== 'BULK_TERMINAL_ADD'}
          errorMessage={fetchGroupDataHandler?.data?.message}
          flex={1}
          onRetry={() => fetchGroupDataApi(entityDetails.parentGroupId, entityDetails.parentSubGroupId)}>
          <Box {...styles.innerContainer}>
            <Box w={220}>
              <NewVerticalStepIndicator
                currentStep={currentStep}
                submitState={''}
                formValidationStatus={formValidationStatus}
                steps={modifiedMapperMetadata(entityDetails, USER_TYPE, loadInitialHandler?.data)?.onBoardingSteps}
                totalFilledStep={
                  modifiedMapperMetadata(entityDetails, USER_TYPE, loadInitialHandler?.data)?.totalFilledStep
                }
                onStepPressed={onStepPressed}
                type={!editable ? 'READ_ONLY' : 'DEFAULT'}
              />
            </Box>
            <Box flex={1}>
              <EntityOnboardingForm
                formRef={formRef}
                currentStep={currentStep}
                onStepPressed={onStepPressed}
                initialValues={entityDetails}
                isEditable={editable}
                fromChekerQueue={true}
                onSubmit={undefined}
                userType={USER_TYPE}
                renderActionButton={renderActionButton}
              />
            </Box>
          </Box>
        </Container>
        <ModBox show={entityDetails?.requestType === 'BULK_TERMINAL_ADD'} f={1} width={'100%'}>
          <Box f={1} width={'100%'}>
            <NewTable
              data={terminals ?? []}
              rowHeight={48}
              headerHeight={64}
              height={'100%'}
              showHeaderCheckBox={editable}
              enableCheckBox={editable}
              customWidthFunc={getCustomColumnWidth}
              tableWidth={width > 1200 ? width - 290 : width}
              headerRowKeys={{
                ...(!['checker2MyQueue'].includes(USER_TYPE) && { check: '' }),
                ...terminalListHeaderTitles,
              }}
              onRowClick={undefined}
              onCheckChange={onCheckChange}
              getIsAllSelected={getIsAllSelected}
            />
          </Box>
          {(editable || ['checker2MyQueue'].includes(USER_TYPE)) && (
            <CheckerDetailsFooter
              show={SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.validStatesForAction?.includes(
                entityDetails?.applicationStatus,
              )}
              isCurrentFormValid={true}
              editable={true}
              onSubmit={onTerminalListSubmit}
              showInternalCommentsField={false}
              showCommentBox={false}
              submitActions={[
                {
                  key: 'APPROVE',
                  description: 'APPROVE',
                },

                {
                  key: 'REJECT',
                  description: 'REJECT',
                },
              ]}
            />
          )}
        </ModBox>
        <FullScreenLoader
          show={uploadEntityStatusHandler.state === 'pending' || updateTerminalsStateHandler?.state === 'pending'}
        />
      </Container>
    </Box>
  )
}

const styles = {
  container: {
    h: '100%',
    borderRadius: 8,
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
  } as BoxProps,
  innerContainer: {
    flexDirection: 'row',
    flex: 1,
  } as BoxProps,
}
export default MyOnboardedEntityDetails

const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    applicationId: 100,
    businessLegalName: 100,
    landlineNumber: 100,
    requestType: 100,
    programCategory: 100,
    createdAt: 100,
    applicationStatus: 100,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

const terminalListHeaderTitles = {
  referenceId: 'Reference Id',
  nickName: 'Nick Name',
  username: 'User Name',
  programIdentifier: 'Program Identifier',
  terminalType: 'TerminalType',
}
